module.exports = __webpack_public_path__ + "static/face.30f16f24.png";